import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/API";

interface digPosData{
    total_ordered_units:number|null;
}

interface digPosState {
  data: digPosData;
  status: string;
  statusCode: number;
  error: string | null;
  isLoading: boolean;
  selectedRow:any;
}
const initialState: digPosState = {
  data: {
    total_ordered_units:null,
  },
  selectedRow:{},
  status: "",
  error: null,
  statusCode: 0,
  isLoading: false,
};

export const FetchdigPos = createAsyncThunk(
  "FetchdigPos",
  async (data:any, { rejectWithValue }) => {
    try {
      const response = await axios.post(API.FETCHDIGPOST,data);
      return response;
    } catch (err: any) {
    //   if (err.response && err.response.data) {
        return rejectWithValue(err);
    //   }
    //   return rejectWithValue("error occurred");
    }
  }
);

const digPosSlice = createSlice({
  name: "digPosData",
  initialState,
  reducers: {
    digPosUpdateRow:(state,action)=>{
      state.selectedRow=action.payload
    },
    emptydigPosData:(state) => {
        state.data = initialState.data;
        state.error = initialState.error;
        state.isLoading = initialState.isLoading;
        state.selectedRow = initialState.selectedRow;
        state.status = initialState.status;
        state.statusCode = initialState.statusCode;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(FetchdigPos.pending, (state) => {

        // state.isLoading = true;

        // state.status = "Loading";
      })
      .addCase(FetchdigPos.fulfilled, (state, action) => {

        // state.isLoading = false;
        state.status = "success";
        state.statusCode = action.payload.status;
        state.data = action.payload.data;
      })
      .addCase(FetchdigPos.rejected, (state,action:PayloadAction<any>) => {

        // state.isLoading = false;
        state.statusCode = action.payload.status;
        state.data.total_ordered_units = null;
        state.status = "Failed";
        state.error = "Error";
      });
  },
});
export const { digPosUpdateRow, emptydigPosData }=digPosSlice.actions
export default digPosSlice.reducer